import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Trungtamsathach from "components/Daotaosathach/Trungtamsathach.js";
export default function DmTrungtamsathach() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Trung tâm sát hạch lái xe",
            tabContent: <Trungtamsathach />,
          },
        ]}
      />
    </div>
  );
}
